import { Loading } from 'module/ui/components/atoms/loading';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: var(--spacing-03) var(--spacing-06);
  width: 100%;
`;
const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const ListLoader = () => (
  <LoadingWrapper>
    <Loading size="large" />
  </LoadingWrapper>
);
